import { createApp } from "vue";
import appConfig from "./configs";
import App from "./App.vue";
import { checkKeycloakLogin } from "./configs/keycloak";
const app = createApp(App);
app.use(appConfig);
checkKeycloakLogin(app, () => {
  app.mount("#app");
})